import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequestWithBody } from "@utils/http-util";
import { injectCustomIdParameter } from "@utils/parameter-injector";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";
import { AXN_RELYING_PARTY_ID_PATTERN } from "@constants/url-parameter-patterns";
import { AxnRelyingParty } from "@idw-types/data/reference-data/axn";

type UpdateAxnRelyingPartyRequestResponse = {
    transferObject: AxnRelyingParty;
};

export const restoreRelyingPartyRequest = async (
    relyingPartyId: string
): Promise<GenericNetworkResponse<UpdateAxnRelyingPartyRequestResponse>> => {
    const route = injectCustomIdParameter(
        apiRoutes.axnadminCore.axn.referencedata.relyingparty.restore,
        relyingPartyId,
        AXN_RELYING_PARTY_ID_PATTERN
    );

    const body = {
        id: relyingPartyId
    };

    const { data, error } = await handleRequestWithBody(RequestTypes.POST, route, body);
    return { data, error, body };
};